export enum PersonalizationFallbackMethod {
  BestSellers = 'best_sellers',
  CustomFallback = 'custom_fallback',
  None = 'none',
}
